/* unplugin-vue-components disabled */import { render } from "./WechatOpenLaunchApp.vue?vue&type=template&id=69b15202&scoped=true"
import script from "./WechatOpenLaunchApp.vue?vue&type=script&lang=js"
export * from "./WechatOpenLaunchApp.vue?vue&type=script&lang=js"

import "./WechatOpenLaunchApp.vue?vue&type=style&index=0&id=69b15202&scoped=true&lang=css"

import exportComponent from "/Users/hongboyuan/projects/yszn-code/qipaoWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b15202"]])

export default __exports__